import en from "./en";
import fin from "./fin";

const strings = {
  en,
  fin,
};

export default strings;
